// 繁体中文
module.exports = {
    public: {
        confirm: '確認',
        cancel: '取消',
        reset: '重置',
        search: '搜尋',
        RefreshSucceeded: '刷新成功',
        noMoreData: '沒有更多數據了',
        pullingText: '下拉即可刷新…',
        ReleaseText: '釋放即可刷新…',
        loadingText: '加載中…',
        noData: '沒有記錄',
        copyTxt: '複製',
        copySuccess: '複製成功',
        amount: '金額',
        buy: '購買',
        orderNo: '訂單號',
        selectLang: '選擇語言',
        light: '亮色',
        dark: '暗色',
        All: '全部',
        DigitalCurrency: '數字貨幣',
        foreignExchange: '外匯',
        futures: '期貨',
        stockIndex: '股指',
        stock: '股票',
        BalanceNot: '餘額不足',
        optional: '自選',
        market: '行情',
        USDTcontract: 'USDT合約',
        Fiatcurrencycontract: '法幣合約',
        spot: '現貨',
        secondContract: '秒合約',
        emptyTxt: '暫無記錄',
    },
    tabBar: {
        home: '首頁',
        market: '發現',
        trade: '交易',
        heel: '理財',
        asset: '資產',
    },
    about: {
        title: '關於我們',
        version: '版本',
        about: '關於',
        ProductIntroduction: '產品介紹',
        Termofservice: '服務條款',
        PrivacyAgreement: '隱私協議',
        Riskstatement: '風險提示',
        whitePaper: '白皮書',
    },
    asset: {
        Overview: '總覽',
        contract: '合約',
        wallet: '錢包',
        Totalassetvaluation: '總資產估值',
        supportswithdrawal: '您存入的每筆資產均支持提現',
        Recharge: '充值',
        Contractaccount: '合約賬戶',
        Spotaccount: '現貨賬戶',
        Walletaccount: '錢包賬戶',
        ValuationContractAssets: '合約資產估值',
        profitloss: '盈虧',
        Transfer: '劃轉',
        occupy: '鎖定',
        available: '可用',
        Viewallpositions: '查看所有倉位',
        Valuationspotassets: '現貨資產估值',
        Hidezerobalanceassets: '隱藏零餘額資產',
        balance: '餘額',
        ValuationWalletAssets: '錢包資產估值',
        Withdrawal: '提現',
        Walletbalance: '錢包餘額',
        Cryptocurrencyrecharge: '加密幣充值',
        Fiatcurrencyrecharge: '法幣充值',
        From: '從',
        To: '到',
        UsdtContractaccount: 'USDT合約賬戶',
        FiatContractaccount: '法幣合約賬戶',
        Currency: '幣種',
        quantity: '數量',
        availablebalance: '可用餘額',
        Insufficientavailablebalance: '可用餘額不足',
        Transfersuccessful: '劃轉成功',
        flashcash: '閃兌',
        flashcashsuccessful: '閃兌成功',
    },
    auth: {
        title: '實名認證',
        gj: '國籍',
        tipsgj: '請選擇國籍',
        userName: '真實姓名',
        tips1: '請輸入真實姓名',
        IDNumber: '證件號碼',
        tips2: '請輸入證件號碼',
        base: '初級認證',
        high: '高級認證',
        zmz: '證件正面照片',
        bmz: '證件背面照片',
        tips3: '請上傳證件正面照片',
        tips4: '請上傳證件背面照片',
        btn: '提交',
        upbtn: '修改證件',
        subMsg: '提交成功，請等待審核',
        upMsg: '修改後將重新審核，確定修改證件？',
        wait: '審核中',
        fail: '認證失敗',
        success: '認證成功',
        cardType: '證件類型',
        idCard: '身份證',
        passport: '護照',
        driverlicense: '駕照',
        AssetCertification: '資產認證',
        AccountType: '帳戶類型',
        holdingamount: '持有金額',
        Accountscreenshot: '帳戶截圖',
        bankaccount: '銀行帳戶',
        IRAaccount: 'IRA 帳戶',
        stockaccount: '股票帳戶',
        other: '其他',
        AccountTypetips: '請選擇帳戶類型',
        Accountscreenshottips: '請上傳帳戶截圖',
    },
    activity: {
        toptit: '福利',
        inviteTxt: '每邀請1名好友您可獲得{amount} USD，最多支持三級分傭',
        invitebtn: '邀請分傭',
        rechargeTxt: '您的下級充值您可獲得{amount}% 分傭，最多支持三級分傭',
        rechargebtn: '充值分傭',
        authTxt: '實名認證成功即送{amount} USD',
        authbtn: '實名認證',
        inviteRewardTxt: '<p><strong>邀請好友，輕鬆拿 30 USD</strong></p><p><br></p><p>一、活動目標</p><p><br></p><p>目標用戶：新老用戶均可參與，鼓勵現有用戶主動邀請好友註冊並完成指定操作，擴大平臺用戶基數。</p><p>核心訴求：通過推薦機制，讓新用戶快速入駐並形成裂變式增長，同時讓邀請人獲得實實在在的獎勵，增強用戶留存與忠誠度。</p><p><br></p><p>二、活動時間</p><p><br></p><p>2023年05月20日 – 長期有效（定期檢查或結束，將另行公告）</p><p><br></p><p>三、參與對象</p><p><br></p><p>凡已完成平臺註冊並通過基礎實名認證的用戶，均可作為邀請人（A）；</p><p>被邀請人（B）需通過邀請鏈接或邀請碼新註冊並完成實名認證才算有效。</p><p><br></p><p>四、參與規則</p><p><br></p><p>邀請方式</p><p>邀請人（A）進入“個人頁面”→“邀請好友”→複製專屬邀請鏈接 / 邀請碼。</p><p>將鏈接/邀請碼分享給好友（B）通過網頁或 APP 進行註冊。</p><p><br></p><p>被邀請人要求</p><p>被邀請人（B）需使用邀請人提供的鏈接或邀請碼完成首次註冊。</p><p>註冊後需在7日內完成實名認證並滿足最低充值標準（例如：首次充值≥1000 USD 或等值代幣）。</p><p><br></p><p>層級劃分</p><p>本活動支持最多三級分傭。</p><p>第一層（直推）：A 直接邀請 B 註冊。</p><p>第二層：B 邀請 C，A 可獲得二級收益</p><p>第三層：C 邀請 D，A 可獲得三級收益</p><p>超過三級（D 邀請 E 及後續）不計入 A 的收益。</p><p><br></p><p>五、獎勵細則</p><p><br></p><p>一級邀請獎勵（直推）</p><p>被邀請人 B 在充值並通過實名認證後，邀請人 A 可獲得 30 USD。</p><p><br></p><p>二級邀請獎勵（間推）</p><p>B 成為邀請人後直接邀請的用戶 C 符合同樣條件時（實名認證＋滿足最低充值），A 可獲得 15 USD。</p><p><br></p><p>三級邀請獎勵（再間推）</p><p>當 C 邀請 D 並滿足條件時，A 可獲得 10 USD。</p><p><br></p><p>獎勵發放方式</p><p>系統自動識別三級邀請關係，當下級（直推或間推）滿足條件後，將在 <strong>48 小時內</strong>將相應獎勵自動發放至邀請人 A 的帳戶資產中。</p><p><br></p><p><br></p><p>六、操作流程示例</p><p><br></p><p>A 登錄 ledger ，進入“個人頁面”→“邀請好友”→複製專屬邀請鏈接 / 邀請碼。</p><p>A 將鏈接/邀請碼發送給好友 B。</p><p>B 點擊鏈接或輸入邀請碼，跳轉至註冊頁→郵箱註冊→完成實名認證並充值 ≥1000 USD。</p><p>好友 B 完成實名認證與充值後，即可聯絡線上服務人員申請獎勵，系統審核通過後自動將 30 USD 獎勵發放給 A（48 小時內到賬）。</p><p>若 B 邀請 C，且 C 同樣完成條件，系統自動將 15 USD 獎勵發放給 A；若 C 邀請 D，D 完成條件後系統自動發放 10 USD 給 A。</p><p><br></p><p>&nbsp;</p><p>七、風控與注意事項</p><p><br></p><p>防止刷獎措施</p><p>每個手機號碼/ 郵箱僅能被邀請一次，同一 IP、身份證等多維度資訊會被風控系統聯動檢測。</p><p>對於同一設備、同一網路環境、大量低質量註冊帳號行為，系統將在後臺進行人工審核，必要時取消相應獎勵。</p><p><br></p><p>違規處罰</p><p>若發現邀請人或被邀請人存在惡意刷獎、套現行為，平臺有權單方面取消所有相關獎勵並凍結帳號。</p><p><br></p><p>&nbsp;</p>',
        rechargeRewardTxt: '<p><strong>下級充值分傭，坐享零等待收益</strong></p><p><br></p><p><strong>一、活動目標</strong></p><p><br></p><p>目標用戶：已完成實名認證的一級邀請人（A），可對其下級（B、C、D）在平臺上進行充值操作時，獲得平臺設定比例的分傭收益，用於培養“裂變鏈條”並提高用戶活躍度。</p><p><br></p><p>核心訴求：通過“充值分傭”機制，將新用戶的充值行為與邀請人利益綁定，形成“邀請-充值-返傭-再邀請”的良性迴圈，促進平臺資金留存與活躍度提升。</p><p><br></p><p><strong>二、活動時間</strong></p><p><br></p><p>常態化活動：自 2023 年 05 月 20 日起，長期有效，根據業務需求調整傭金比例或活動截止時間提前公告。</p><p><br></p><p><strong>三、參與對象</strong></p><p><br></p><p>邀請人 A：必須是完成實名認證的用戶，且已成功邀請至少一名下級完成實名認證（成為 B）。</p><p><br></p><p>下級 B、C、D：指被 A 邀請或被其下級邀請形成的第二三級用戶鏈，且下級在平臺進行充值行為時，A 階段可獲取分傭收益。</p><p><br></p><p><strong>四、參與規則</strong></p><p><br></p><p><strong>層級關係：</strong></p><p><br></p><p>第一層（直推B）：若 B 完成充值（充值法幣或其他代幣，滿足最低充值金額），系統將根據充值金額的 1%（見下方收益規則）返傭給 A。</p><p>第二層（B 邀請 C）：若 C 完成充值，A 可獲得C充值金額的0.5%傭金</p><p>第三層（C 邀請 D）：若 D 完成充值，A 可獲得D充值金額的0.3%傭金（更低比例）。</p><p>僅支持三級分傭，超過此層級的充值行為不再產生對 A 的分傭。</p><p><br></p><p><strong>充值管道與最低額度：</strong></p><p><br></p><p>支持平臺支持的所有充值管道（法幣充值或多網路加密資產充值），但單筆充值需滿 1000 USD 等值，方可計入傭金計算基數；</p><p><br></p><p><strong>分傭比例</strong></p><p><br></p><p>一級 B 1.0% 例如 B 充值 1000 USD，A 可得 10 USD</p><p>  </p><p>二級 C 0.5% 例如 C 充值 1000 USD，A 可得 5 USD</p><p><br></p><p>三級 D 0.3% 例如 D 充值 1000 USD，A 可得 3 USD</p><p><br></p><p><strong>分傭發放方式</strong></p><p><br></p><p>平臺會在下級完成充值且資金到賬後24 小時內，將相應分傭自動發放至邀請人 A 的交易帳戶中；</p><p>用戶可在“我的錢包”→“傭金明細”查看每筆分傭來源、金額與發放時間。</p><p><br></p><p><strong>五、操作流程示例</strong></p><p><br></p><p>A 登錄 APP→進入“個人頁面”→“邀請好友”→複製專屬邀請鏈接 / 邀請碼。。</p><p>A 將推薦鏈接/邀請碼提供給 B。</p><p>B 新註冊→完成實名認證→儲值（至少 1000 USD）。</p><p>充值到賬後，系統自動計算：B 充值總額 × 1%= A 獲得傭金。24小時內，該筆傭金打入 A 的活動帳戶。</p><p><br></p><p>B 作為邀請人後，可邀請 C。若 C 充值，系統自動計算 B 與 A 兩級分傭：</p><p>B 獲得 C 充值 × 1%；</p><p>A 獲得 C 充值 × 0.5%。</p><p><br></p><p>C 可邀請 D，若 D 充值，則產生三級分傭：</p><p>C 獲得 D 充值 × 1%；</p><p>B 獲得 D 充值 × 0.5%；</p><p>A 獲得 D 充值 × 0.3%。</p><p><br></p><p><strong>六、風控與注意事項</strong></p><p><br></p><p><strong>防止惡意套利</strong></p><p><br></p><p>同一用戶不得與自身帳號進行迴圈充值；平臺會對異常小額多次充值、短時間內大額充值並提現行為進行日誌與風控檢測，必要時人工審核並取消分傭。</p><p>對充值後迅速撤銷且存在高頻操作特徵的用戶，系統可視為惡意套利並取消相關分傭。</p><p><br></p><p><strong>合規審查</strong></p><p><br></p><p>若系統或後臺風控檢測到被邀請人存在洗錢、套現風險，平臺有權凍結該用戶及相關鏈條的所有傭金，並保留向監管部門報備的權利。</p><p><br></p><p><br></p>',
        authRewardTxt: '<p><strong>實名認證即送 50 USD</strong></p><p><br></p><p>一、活動目標</p><p><br></p><p>目標用戶：平臺新註冊用戶及老用戶（若此前未完成實名認證）均可參與，主要吸引新用戶完成實名認證並留存，同時鼓勵因實名認證流程繁瑣而猶豫的用戶儘快通過認證。</p><p>核心訴求：通過發放現金獎勵直觀刺激用戶完成實名認證環節，提升風控品質與 KYC 覆蓋率，保證平臺合規運營。</p><p><br></p><p>二、活動時間</p><p><br></p><p>2023年05月20日 – 長期有效</p><p><br></p><p>三、參與對象</p><p><br></p><p>新用戶：首次在 ledger 平臺註冊且在活動期間完成實名認證。</p><p>老用戶：在活動開始前註冊但尚未實名認證的用戶，需在活動期內完成實名認證方可獲得獎勵。</p><p><br></p><p>四、參與規則</p><p><br></p><p>實名認證要求</p><p>用戶需上傳清晰的身份證件（身份證/護照/駕照等）正反面照片，以及本人手持證件半身照；</p><p>人臉識別驗證需保證光線充足、五官無遮擋，符合平臺活體檢測要求；</p><p>完成提交後，一般審核時間在24 小時內完成</p><p><br></p><p>獎勵金額</p><p>所有在活動期內成功完成實名認證的用戶（新老用戶皆可），即送 50 USD </p><p><br></p><p>領取方式與發放時間</p><p>用戶實名認證通過後，系統將在 24 小時內將 50</p><p>USD 獎勵匯入法幣合約帳戶；完成10次正常交易之後即可提款。</p><p><br></p><p>若因提交資料不完整或審核不通過，用戶需根據系統提示補充資料後再次審核，審核通過後才能拿到獎勵。</p><p><br></p><p>五、操作流程示例</p><p><br></p><p>用戶登錄APP→“實名認證”→開始實名認證流程。</p><p>上傳身份證/護照/駕照正反面照片</p><p>系統自動比對證件資訊，若未通過需根據提示重拍。</p><p>審核通過後，系統在 24 小時內將 50USD 獎勵發放至“法幣合約帳戶”。</p><p><br></p><p>六、風控與注意事項</p><p><br></p><p>防止惡意刷獎</p><p>同一身份證件僅能領取一次獎勵；同一 IP、同一設備號同時申請多張證件的行為，系統會觸發風控限制，需人工審核或直接拒絕。</p><p>對明顯使用虛假、篡改或 P 圖過的證件圖片，一經發現直接拒絕並凍結帳號。</p><p><br></p><p>資料隱私保護</p><p>平臺承諾所有身份證件及人臉識別數據僅用於合規風控與 KYC 審核，未經用戶許可絕不外泄；</p><p>在審核通過後，用戶上傳的證件照片與視頻將按相關法律法規要求進行加密存儲，符合監管要求。</p><p><br></p><p><br></p><p>&nbsp;</p>',
    },
    bill: {
        title: '資金明細',
        audit: '待審核',
        success: '成功',
        refuse: '拒絕',
        recharge: '充值',
        recharge_currency: '充幣',
        recharge_legal: '法幣入金',
        withdrawal: '提現',
        withdrawal_currency: '提幣',
        cancel_withdrawal_currency: '取消提幣',
        withdrawal_legal: '取款',
        cancel_withdrawal_legal: '取消取款',
        transfer: '劃轉',
        usdt_contract_wallet: 'USDT合約->錢包',
        legal_contract_wallet: '法幣合約->錢包',
        coin_currency_wallet: '現貨->錢包',
        wallet_usdt_contract: '錢包->USDT合約',
        wallet_legal_contract: '錢包->法幣合約',
        wallet_coin_currency: '錢包->現貨',
        finance_wallet: '理財->錢包',
        wallet_finance: '錢包->理財',
        usdt_contract_currency: 'USDT合約->現貨',
        finance_currency: '理財->現貨',
        currency_usdt_contract: '現貨->USDT合約',
        currency_finance: '現貨->理財',
        legal_contract_currency: '法幣合約->現貨',
        currency_legal_contract: '現貨->法幣合約',
        recharge_reward: '下級充值分傭',
        auth_reward: '實名認證獎勵',
        flashcash: '閃兌',
        trade: '交易',
        create_order: '下單',
        settlement_order: '訂單結算',
        cancel_order: '取消訂單',
        finance_return: '理財返本',
        finance_income: '理財收益',
        other: '其他',
        commission_transfer: '佣金轉入',
        platform_gift: '平台贈送',
        system_regulation: '餘額變動',
        freeze_thaw: '凍結解凍',
        c2c_create_order: 'C2C下單',
        c2c_cancel_order: 'C2C取消訂單',
        Currency: '幣種',
        type: '類型',
        SelectCurrency: '選擇幣種',
        SelectType: '選擇類型',
        SelectDate: '日期選擇',
        to: '至',
        Contractfunds: '合約資金',
        Spotfunds: '現貨資金',
        Walletfunds: '錢包資金',
        RechargeRecord: '充值記錄',
        WithdrawalRecord: '提現記錄',
        virtualcoin: '虛擬幣',
        Legaltender: '法幣',
    },
    c2c: {
        limit: '限額',
        available: '可用',
        price: '單價',
        needpay: '您需支付',
        willreceive: '您將獲得',
        Insufficientlimit: '不足限額',
        Exceedinglimit: '超出限額',
        Exceedingavailable: '超出可用',
        balance: '餘額',
        InsufficientBalance: '餘額不足',
        OrderHistory: '訂單歷史',
        quantity: '數量',
        amountmoney: '金額',
        OrderNo: '訂單號',
        inprogress: '進行中',
        Completed: '已完成',
        Cancelled: '已取消',
        all: '全部',
        chat: '聊天',
        picture: '[圖片]',
        Read: '已讀',
        Unread: '未讀',
        inputTips: '在此輸入你的對話',
        send: '發送',
    },
    common: {
        title: '全部功能',
        Depositcoins: '充幣',
        Rechargefiatcurrency: '法幣入金',
        Withdraw: '取款',
        documentation: '理財',
        Activecenter: '活動中心',
        Invitationforrebate: '邀請返傭',
        Detailsoffunds: '資金明細',
        Positiondetails: '持倉明細',
        Notice: '資訊',
        Aboutus: '關於我們',
        helpcenter: '幫助中心',
        customer: '客服',
        Cryptocurrencywithdrawal: '加密幣取款',
        Fiatmoneywithdrawal: '法幣取款',
        DepositcoinsTips: '簡單流程，快速買幣',
        RechargefiatcurrencyTips: '通過法幣管道充值USD',
        USDTcontractTips: '多種以USDT結算的合約',
        FiatcurrencycontractTips: '多種以法幣結算的合約',
        TransferTips: '一鍵兌換成不同的加密貨幣資產',
        c2cTips: '通過靈活支付方式0交易費買賣加密貨幣',
    },
    forgotPass: {
        title: '重置密碼',
        btn: '確認',
        Password: '新密碼',
        placeholder: '請輸入新密碼',
        success: '設置成功',
    },
    finance: {
        financeAssetAmount: '理財資產估值',
        financeAccount: '理財帳戶',
        financefund: '理財資金',
        financeProduct: '理財產品',
        Applynow: '立即申購',
        term: '期限',
        investment: '投資金額',
        Mininvestment: '最低投資額',
        Maxinvestment: '最高投資額',
        buyNum: '購買次數',
        Myincome: '我的收益',
        Dailyearnings: '每日收益',
        yieldmaturity: '到期收益',
        timeaxis: '時間軸',
        Subscriptiondate: '申購日',
        valuedate: '起息日',
        duedate: '到期日',
        Receiptdate: '到帳日',
        day: '天',
        financeOrderList: '理財記錄',
        interestrate: '利率',
        Revenueamount: '收益金額',
        Settlementamount: '結算金額',
        regularly: '定期',
        eecurrent: '活期',
        redemption: '贖回',
        redemptionTips: '確認贖回該理財產品',
        loan: '貸款',
        LoanRange: '借款區間',
        LoanAmount: '借款金額',
        loanTerm: '借款期限',
        Dailyinterestrate: '日利息率',
        Totalinterest: '總利息',
        Repaymentmethod: '還款方式',
        Repaymentofmaturity: '到期一次性還本息',
        Estimatedreturn: '預估應還',
        Ihavereadandagree: '我已閱讀並同意',
        LoanAgreement: '借款協議',
        Immediatelymoney: '立即借款',
        Minimumloanamount: '最低借款金額',
        Maximumloanamount: '最高借款金額',
        Applicationsuccessfulreview: '申請成功，等待後台審核',
        Loanrecords: '貸款記錄',
        Pendingreview: '待審核',
        issued: '已下發',
        Repaid: '已還款',
        Rejected: '已拒絕',
        LoanDate: '借款日',
        AmountDue: '應還金額',
        repayment: '還款',
        loanTTips: '迅速到帳，可選多時間質押',
        homeAddress: '詳細家庭地址',
        homeAddressTips: '請輸入詳細家庭地址',
        emergencyContact: '緊急聯絡人',
        emergencyContactTips: '請輸入緊急聯絡人',
        emergencyPhone: '緊急聯絡人手機號碼',
        emergencyPhoneTips: '請輸入緊急聯絡人手機號碼',
        emergencyEmail: '緊急聯絡人郵箱',
        emergencyEmailTips: '請輸入緊急聯絡人郵箱',
        isHouse: '是否有屬於自己的房產',
        houseImg: '如有房產請提供房產歸屬證明圖片',
        certImg: '證件正面 (身份證/護照/駕駛證)',
        certImgTips: '請上傳證件正面 (身份證/護照/駕駛證)',
        certBackImg: '證件反面 (身份證/護照/駕駛證)',
        certBackImgTips: '請上傳證件反面 (身份證/護照/駕駛證)',
        trustImg: '信用分截圖',
        trustImgTips: '請上傳信用分截圖',
        yesTxt: '是',
        noTxt: '否',
        EstimatedReturn: '預計收益',
        seeDetail: '查看詳情',
        orderDetails: '訂單詳情',
    },
    heel: {
        tips: '敬請期待~',
    },
    home: {
        optional: '自選',
        HotList: '熱門榜',
        more: '更多',
        Capturetrading: '捕獲交易良機',
        Exploreproducts: '探索我們的產品',
        Contracttrading: '合約交易',
        Spottrading: '理財',
        ContracttradingTips: '備受喜愛的槓桿衍生品，最高支持100倍。支持多空操作，只要有波動，就有盈利機會',
        SpottradingTips: '最小的成本，最大的收益。隨時隨地，開啟交易',
        starttrading: '開始交易',
        Tradeanytime: '隨時隨地進行交易',
        Scandownload: '掃描下載',
        hundredmillion: '億',
        thousand: '萬',
        year: '年',
        transactionvolume: '24小時交易額',
        openinterest: '24小時持倉量',
        RegisteredUser: '註冊用戶',
        Ensuresafetyfunds: '保障資金安全',
        Reasonschoosingus: '選擇我們的理由',
        mobeginwith: '始於',
        Topliquidity: '頂尖流動性',
        Effectivelyusers: '切實保障用戶權益',
        TradeNow: '立即交易',
        Needhelp: '需要幫助',
        helpcenter: '幫助中心',
        helpcenterTips: '提供常見問題的幫助，獲取特定功能的詳細說明。',
        Learnmore: '了解更多',
        Onlinecustomerservice: '線上客服',
        OnlinecustomerserviceTips: '提供24/7的客服支持，隨時隨地為您提供服務。',
        PlatformAnnouncement: '平台公告',
        PlatformAnnouncementTips: '提供最新資訊，及時了解掌握一手的交易信息。',
        Starttradingnow: '立即開啟您的加密貨幣交易之旅！',
        Trademillions: '在數百萬用戶信任的平台上進行交易',
        Storingbuyingcoins: '儲值或買幣',
        product: '產品',
        service: '服務',
        guide: '指南',
        agreedannouncement: '協議聲明',
        customerservice: '客戶服務',
        Riskstatement: '風險提示：數字資產交易是一個新興產業，存在光明前景，但正因為屬於新事物，也蘊含巨大風險。特別是在槓桿交易中，槓桿倍數既同步擴大了盈利也同步放大了風險，請您務必對此行業、槓桿交易模式、交易規則等相關知識有充分了解後再參與。我們強烈建議您，在自身能夠承擔的風險範圍內進行交易。交易有風險，入市須謹慎！',
        topTips: '一個帳戶，無限可能',
        coin: '現貨交易',
        coinTips: '即時即刻，公開透明，隨時隨地開啟你的現貨交易之旅',
    },
    login: {
        title: '登入',
        Account: '登入帳號',
        Password: '密碼',
        btn: '登入',
        placeholder: '請輸入手機號碼',
        placeholder1: '請輸入密碼',
        ForgotPassword: '忘記密碼',
        noAccount: '沒有帳號？',
        Registration: '註冊',
        server: '聯繫客服',
        success: '登入成功',
        checkedAgree: '請先同意隱私協議',
        rememberpassword: '記住密碼',
        agreewith: '同意',
        PrivacyAgreement: '隱私協議',
    },
    market: {
        product: '產品',
        Latestprice: '最新價格',
        volume: '成交量',
        ChangeRatio: '漲跌幅',
        Addoptional: '添加自選',
        optional: '自選',
        market: '行情',
        Editselfselection: '編輯自選',
        operate: '操作',
        SelectAll: '全選',
        delete: '刪除',
        time: '時間',
    },
    position: {
        title: '持倉明細',
        totalassets: '總資產',
        profitloss: '盈虧',
        Holdingassets: '持倉資產',
        margin: '保證金',
        orderAmount: '訂單金額',
        availableassets: '可用資產',
        product: '產品',
        direction: '方向',
        Entrustedprice: '委託價格',
        Entrustednum: '委託數量',
        Currentprice: '當前價格',
        Stoplossprice: '止損價格',
        stopSurplusPrice: '止盈價格',
        Leverageratio: '槓桿倍數',
        Entrustedtime: '委託時間',
        orderno: '訂單編號',
        marketvalue: '市值',
        SettlementPrice: '結算價格',
        Settlementtime: '結算時間',
        Settakeprofitloss: '設置止盈止損',
        closeposition: '平倉',
        Position: '當前委託',
        commission: '歷史委託',
        Settlement: '歷史成交',
        Settingsuccessful: '設置成功',
        Confirmclosingorder: '確認平倉該訂單',
        Closingsuccessfully: '平倉成功',
        cancelorder: '確認取消該訂單',
        Cancelsuccessfully: '取消成功',
        status: '狀態',
        changeRate: '手續費',
    },
    property: {
        title: '資產明細',
        totalassets: '總資產',
        profitloss: '盈虧',
        Holdingassets: '持倉資產',
        margin: '保證金',
        availableassets: '可用資產',
        investmentportfolio: '投資組合',
        Recentincomesituation: '最近收益情況',
        Seemore: '查看更多',
        IncomeDetails: '收益明細',
    },
    recharge: {
        mixAmount: '最小充值金額',
        subMsg: '提交成功，請等待審核',
        amountMsg: '請輸入金額',
        VoucherMsg: '請上傳支付憑證',
        Depositcoins: '充幣',
        Rechargecurrency: '充值幣種',
        RechargecurrencyTips: '充幣數量大於 200USDT，快速到賬',
        Depositaddress: '充幣地址',
        Rechargetoaccount: '充值到賬',
        Walletaccount: '錢包帳戶',
        Rechargequantity: '充值數量',
        Paymentvoucher: '支付憑證',
        Youneedtorecharge: '您需充值',
        Rechargenow: '立即充值',
        Rechargefiatcurrency: '法幣入金',
        Topupfiatcurrency: '充值法幣',
        paymentcurrency: '支付幣種',
        paymentcurrencyTips: '充值金額大於 200USD，快速到賬',
        Fiatcontractaccount: '法幣合約帳戶',
        Rechargeamount: '充值金額',
        Youwillget: '您將獲得',
        network: '網絡',
        notsupportedAddress: '不支持當前地址',
        selectaccount: '請選擇帳戶',
    },
    register: {
        title: '註冊',
        send: '發送驗證碼',
        Resend: '重新發送',
        sendSuccess: '發送成功',
        PhoneNumber: '手機號碼',
        Mailbox: '電子郵箱',
        Captcha: '驗證碼',
        Password: '密碼',
        ConfirmPassword: '確認密碼',
        PromoteCode: '推廣代碼',
        OrgCode: '機構代碼',
        btn: '註冊',
        placeholder0: '請輸入手機號碼',
        placeholder1: '請輸入密碼',
        placeholder2: '請輸入確認密碼',
        placeholder3: '請輸入推薦人ID',
        placeholder4: '請輸入驗證碼',
        placeholder5: '請輸入電子郵箱',
        emaiError: '郵箱格式不正確',
        success: '註冊成功',
        message: '密碼至少6位',
        message1: '確認密碼至少6位',
        message2: '兩次密碼不匹配',
        searchCountryMsg: '請輸入國家、區號搜尋',
        haveAccount: '已有帳號？',
        goLogin: '登入',
        titleTips: '從註冊開始！',
        Invitationcode: '邀請碼',
        Iagreewith: '創建帳戶即表示我同意',
        and: '和',
    },
    safe: {
        SecuritySettings: '安全設置',
        Accountsecurity: '帳戶安全',
        phone: '手機',
        Notyetbound: '未綁定',
        mailbox: '郵箱',
        Loginpassword: '登入密碼',
        Fundcode: '資金密碼',
        Settings: '設置',
        Withdrawaladdressmanagement: '提幣地址管理',
        Addwithdrawaladdress: '添加提幣地址',
        Withdrawalcurrency: '提幣幣種',
        Withdrawaladdress: '提幣地址',
        WithdrawaladdressTips: '請輸入提幣地址',
        remark: '備註',
        confirm: '確認',
        Addedsuccessfully: '添加成功',
        Pleaseselectcurrency: '請選擇幣種',
        Bindmailbox: '綁定郵箱',
        Bindmobilephone: '綁定手機號碼',
        ChangeLoginPassword: '修改登入密碼',
        Setfundpassword: '設置資金密碼',
        BindmailboxTips: '請先綁定郵箱，去綁定？',
        Addnewaddress: '添加新地址',
        Confirmdeleteaddress: '確認刪除該提幣地址',
    },
    share: {
        title: '分享賺錢',
        commission: '佣金',
        Commissionrecord: '佣金記錄',
        Commissiontransferout: '佣金轉出',
        Transferoutrecord: '轉出記錄',
        Invitefriends: '邀請好友',
        Invitationrecord: '邀請記錄',
        Commissioncommission: '佣金抽成',
        ReferralCode: '推薦碼',
        Firstlevelmembers: '第一級成員',
        Secondlevelmembers: '第二級成員',
        Thirdlevelmembers: '第三級成員',
        Transferbalance: '轉到餘額',
        Confirmtransferout: '確認轉出',
        Transfersuccessful: '轉出成功',
        amount: '轉出金額',
        Transferfiaaccount: '轉到法幣合約帳戶',
    },
    trade: {
        high: '24h最高價',
        low: '24h最低價',
        vol: '24h交易量',
        buy: '買',
        sell: '賣',
        buyBtn: '買入',
        sellBtn: '賣出',
        Present: '市價單',
        Limit: '限價單',
        limitMsg: '價格',
        markPriceMsg: '以當前最優價',
        num: '數量',
        zyzsSet: '設置止盈止損',
        zyPrice: '止盈',
        zsPrice: '止損',
        smallMin: 'M',
        hour: 'H',
        dayMin: 'D',
        Position: '持倉',
        Viewalltransactions: '查看全部交易',
        product: '產品',
        direction: '方向',
        Entrustedprice: '委託價',
        Entrustednum: '委託數量',
        Latestprice: '最新價',
        volume: '成交量',
        ChangeRatio: '漲跌幅',
        buyBtnConfirm: '確認買入',
        sellBtnConfirm: '確認賣出',
        totalAmount: '金額',
        Margin: '保證金',
        balance: '可用',
        buyLimtMsg: '開多只能輸入比市場價低的價格',
        sellLimtMsg: '開空只能輸入比市場價高的價格',
        putNummsg: '請輸入數量',
        putLimitPriceMsg: '請輸入限價',
        pleaseAuth: '請先實名認證',
        orderSuccess: '交易成功',
        Fullwarehouse: '全倉',
        corkado: '可開多',
        Kato: '開多',
        openable: '可開空',
        Openempty: '開空',
        purchasable: '可買',
        vendibility: '可賣',
        Orderconfirmation: '確認下單',
        Averageopeningprice: '開倉均價',
        Marketprice: '市價',
        Openingquantity: '開倉數量',
        Stoplossprice: '止損價',
        stopSurplusPrice: '止盈價',
        Averageprice: '均價',
        buyLimtMsg2: '買入只能輸入比市場價低的價格',
        sellLimtMsg2: '賣出只能輸入比市場價高的價格',
        authTips: '請先實名認證，去認證',
        profundity: '深度',
        deal: '成交',
        contract: '合約',
        TradeNow: '立即交易',
        CloseTime: '休市',
        buyUp: '買漲',
        buyDown: '買跌',
        selectSeconds: '選擇到期時間',
        buyNums: '買入金額',
        minbuyNums: '最低買入',
        incomeRates: '收益率',
        buySuccessTips: '購買成功',
        secondNums: '秒數',
        simulatedTrading: '模擬交易',
    },
    upPassword: {
        title: '修改密碼',
        oldPassword: '原密碼',
        oldPasswordMsg: '請輸入原密碼',
        newPassword: '新密碼',
        newPasswordMsg: '請輸入新密碼',
        twoPassword: '確認密碼',
        twoPasswordMsg: '請輸入確認密碼',
        twoinputMsg: '兩次輸入密碼不同',
        passwordTypeMsg: '密碼要求6位數字',
        submsg: '修改成功',
        btn: '確認修改',
    },
    user: {
        Avatarchange: '頭像更換',
        Replacesuccessfully: '更換成功',
        authenticated: '已認證',
        Notcertifiedyet: '未認證',
        Invitefriends: '邀請好友',
        Activecenter: '活動中心',
        Identityauthentication: '身份認證',
        Completedverification: '已完成驗證',
        Tobeverified: '待驗證',
        SecuritySettings: '安全設置',
        Lang: '選擇語言',
        changeTheme: '切換主題',
        helpcenter: '幫助中心',
        Aboutus: '關於我們',
        out: '退出登錄',
        outmsg: '確認退出登錄',
        trustscore: '信用分',
    },
    welcome: {
        title1: '業內領先的市場流動性',
        tips1: '99%的訂單在最高價位上執行',
        title2: '12年的信賴',
        tips2: '隨時隨地在可靠的平台上交易加密貨幣',
        title3: 'VIP專屬福利',
        tips3: '成為VIP享交易、兌換、出金等手續費折扣',
        title4: '100,000USDT模擬交易金',
        tips4: '練習交易無風險',
        bnt1: '註冊即領 10 USDT',
        bnt2: '登入',
    },
    with: {
        Withdrawcurrency: '提幣',
        currencyofwithdrawal: '提現幣種',
        Withdrawaladdress: '提幣地址',
        Addwithdrawaladdress: '添加提幣地址',
        Withdrawalquantity: '提幣數量',
        availablebalance: '可用餘額',
        WithdrawaladdressTips: '該幣種還未設置提幣地址，去設置？',
        selectWithdrawaladdress: '請選擇提幣地址',
        Insufficientavailablebalance: '可用餘額不足',
        Withdrawingfiatcurrency: '法幣取款',
        Withdrawaloffiatcurrency: '取款法幣',
        Currentbalance: '當前餘額',
        Currencyreceived: '到賬幣種',
        WithdrawingfiatcurrencyTips: '取款金額大於 200USD，快速到賬',
        Withdrawalaccount: '取款帳戶',
        Fiatcontractaccount: '法幣合約帳戶',
        Withdrawalamount: '取款金額',
        Youneedwithdrawmoney: '您需取款',
        Youwillget: '您將獲得',
        Withdrawimmediately: '立即取款',
        mixAmount: '最小提現金額',
        subMsg: '提交成功，請等待審核',
    },
}